<template>
    <div class="recommendNote" ref="recommendContainer" v-if="ids">
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="relatedTitleBox" v-if="!isLoading">
            <div class="relatedTitle">推薦文章</div>
            <a href="article" class="more">更多文章</a>
        </div>

        <a :href="'article/'+item.slug" v-for="item in recommends" :key="item.id">
            <div class="recommendItem">
                <div class="recommendTitle">{{ item.title }}</div>
                <input type="hidden" class="type_id_specId_key"
                       :data-type_id_specId_key="item.typeIdSpecIdKey"
                       name="type_id_specId_key[]" :value="item.typeIdSpecIdKey">
                <div class="recommendCreatedAt">{{ formatDate(item.postAt) }}</div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: 'RecommendNoteComponent',
    props: {
        ids: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
    },
    data() {
        return {
            isLoading: true,
            recommends: [],
            url: '/api/recommendNote',
        };
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.ids) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        formatDate(dateString) {
            const options = { month: 'short', day: '2-digit', year: 'numeric' };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.ids}`);
                this.recommends = response.data;
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
.spinner-border {
    margin: 50px 50%;
}
</style>
